import { useQuery } from '@tanstack/react-query';
import TreatmentPlanApi from '@/api/treatmentPlanApi';
import { TreatmentPlanResponse } from '@/schema/treatmentPlan';

// Treatment plan (weekly correction steps) for a scan.
export const useTreatmentPlan = (scanId: string, options?: { enabled?: boolean }) => {
  return useQuery<TreatmentPlanResponse>({
    queryKey: ['treatmentPlan', scanId],
    queryFn: () => TreatmentPlanApi.getByScanId(scanId),
    enabled: options?.enabled ?? Boolean(scanId),
  });
};
